import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./layout/AppLayout";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { LocalizeProvider } from "./hooks/useLocalize";

// Importing Sass with Bootstrap CSS
import "./css/app.scss";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <LocalizeProvider>
        <App />
      </LocalizeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if (container?.dataset.prerendered === "true") {
  hydrateRoot(container, app);
} else {
  createRoot(container!).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
